import { findViolationData } from "../../api/config/modules/ViolationControl";

const state = {
    findViolationData: {},
};

const mutations = {
  SET_FINDVIOLATIONDATA: (state, findViolationData) => {
    state.findViolationData = findViolationData;
  },
};

const actions = {
  GET_FINDVIOLATIONDATA: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        findViolationData(data).then((res) => {
          commit("SET_FINDVIOLATIONDATA", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
